function Germany({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1234)">
  <path d="M0.995239 21.5651C3.25593 27.6578 9.12061 31.9999 16 31.9999C22.8795 31.9999 28.7442 27.6578 31.0049 21.5651L16 20.1738L0.995239 21.5651Z" fill="#FFDA44"/>
  <path d="M16 0C9.12061 0 3.25593 4.342 0.995239 10.4348L16 11.8261L31.0049 10.4347C28.7442 4.342 22.8795 0 16 0Z" fill="black"/>
  <path d="M0.995188 10.4346C0.352063 12.1679 0 14.0426 0 15.9998C0 17.9569 0.352063 19.8316 0.995188 21.5649H31.0049C31.648 19.8316 32 17.9569 32 15.9998C32 14.0426 31.648 12.1679 31.0048 10.4346H0.995188Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Germany;
